import React, { FunctionComponent, ReactNode } from 'react';
import { baseStyle } from './Terms.style';
import LayoutWrapper from '../../../layouts/layout-wrapper/LayoutWrapper';
import { WrapperSize } from '../../../types';

export interface TermsProps {
  children: ReactNode,
}

const Terms: FunctionComponent<TermsProps> = ({ children }) => (
  <LayoutWrapper maxWidth={WrapperSize.M}>
    <div css={baseStyle}>
      {children}
    </div>
  </LayoutWrapper>
);

export default Terms;
